import { createSelector } from 'reselect';
import { careerAndSeasonStatsSelector } from './simple-selectors';

export const careerAndSeasonStatsDataTypeSelector = createSelector(
    careerAndSeasonStatsSelector,
    (careerAndSeasonStats) => careerAndSeasonStats.dataType
);
